import { getAuthApiURL, getLocalStorage, getServiceCode } from '../utils';

const logApp = async (appUsername: string, appPassword: string) => {
  const response = await fetch(getAuthApiURL() + '/login_check', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: new URLSearchParams({
      _username: appUsername,
      _password: appPassword,
    }),
  });
  const responseJson = await response.json();
  // On le token et le refreshToken
  if (responseJson.token) {
    return responseJson.token;
  } else {
    throw new Error('failed to authenticated app');
  }
};

const checkService = async (appToken: string) => {
  const response = await fetch(getAuthApiURL() + '/system/service/' + getServiceCode(), {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Bearer ' + appToken,
    },
  });

  const responseJson = await response.json();
  // On le token et le refreshToken
  if (responseJson.isActive !== undefined) {
    return responseJson.isActive;
  } else {
    throw new Error(getServiceCode() + ' service is disabled or not found');
  }
};

export const authenticateApp = async (appUsername: string, appPassword: string) => {
  const appToken = await logApp(appUsername, appPassword);
  getLocalStorage().setItem('app_token', appToken);
  let isServiceActive;
  try {
    isServiceActive = await checkService(appToken);
  } catch (e) {
    isServiceActive = false;
  }

  return { appToken, isServiceActive };
};
